import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BiArrowBack } from "react-icons/bi";
import { Footer, Header, Skills, Testimonial, Work } from "../container";
// import { useNavigate } from "react-router-dom";
import { Navbar } from "../components";
import {
  Routes,
  Route,
  Link,
  NavLink,
  Outlet,
  Navigate,
} from "react-router-dom";
import "./Page.scss";
import "./Page404.scss";
// import Messages from "./Messages";

// const navigate = useNavigate();
const Page404 = () => (
  <motion.div
    className="main"
    initial={{ opacity: 0 }}
    exit={{ opacity: 0 }}
    animate={{ opacity: 1 }}
  >
    <h2>404</h2>
    <p>Whoops, the info you're looking for can't found.</p>
    <Link className="back" to="/">
      <BiArrowBack style={{ verticalAlign: "bottom" }} /> go to homepage
    </Link>
  </motion.div>
);

export default Page404;
